import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Landing
import HomePage from './pages/HomePage';
import {AnalyticsGate, CookieBanner} from "./api/CookieBanner";

export default function App() {
    return (
        <BrowserRouter>
            <AnalyticsGate />
            <CookieBanner />
            <Routes>
                <Route path="/" element={<HomePage />} />
            </Routes>
        </BrowserRouter>
    );
}
